import { AskDictationSlotComponent } from '#pplx/frontend/apps/ask/composer-sdk-plugins/dictation/AskDictationSlotComponent.js';
import { createPluginFactory } from '#pplx/frontend/composer-sdk/plugins/createPluginFactory.js';
export const createAskDictationControlPlugin = createPluginFactory({
    name: 'dictation',
    capabilities: [
        {
            kind: 'slot',
            components: [
                {
                    slot: 'rightAttribution',
                    component: AskDictationSlotComponent,
                },
            ],
        },
    ],
});
//# sourceMappingURL=askDictationControlPlugin.js.map